jQuery.noConflict();
/**** Code For original Device Select Drop down to handle change event****/
jQuery(document).ready(function(){
  jQuery("#device_select").change(function(){
	 var val = jQuery(this).val();
     switchDevice(val);
    });
});